jQuery(document).ready(function ($) {
    const $title = $('.bocss-title');
    if ($title.length) {

        //Only run any of this stuff when there is a component on the page
        const $progress = $('.bocss-title__progress');

        const $window = $(window);
        const $document = $(document);
        const $topBarWrap = $('.top-bar-wrap');
        const $navbar = $('.navbar');
        const $header = $('header');

        // Default
        var checkHeight = 120;

        // Sites have different headers
        // DESIGN
        if ($topBarWrap.length) {
            checkHeight = $topBarWrap.height() + $navbar.height();
        // EWS
        } else if ($header.length) {
            checkHeight = $header.height();
        }

        $window.scroll(function () {
            const progressPercent = 100 * $window.scrollTop() / ($document.height() - $window.height());
            const activeClass = 'bocss-title--active';

            $progress.css('width', progressPercent + '%');

            if ($window.scrollTop() >= (checkHeight)) {
                $title.addClass(activeClass);
            } else {
                $title.removeClass(activeClass);
            }
        });

    }//endif
});
